<template>
  <b-modal
    id="whatsapp-settings-modal"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    centered
  >
    <template #modal-title>
      WhatsApp Settings
      <span
        v-if="$route.meta.help"
        class="ml-1"
      >
        <a
          :href="$route.meta.help"
          target="_blank"
        >
          <feather-icon
            v-b-tooltip.hover.v-primary="'Click to view user guide'"
            icon="HelpCircleIcon"
            size="15"
            class="cursor-pointer text-primary"
          />
        </a>
      </span>
    </template>
    <b-form @submit.prevent>
      <b-row>
        <b-col md="4">
          <b-form-group
            label-for="mc-whats-app-token"
            label="WhatsApp Token"
          >
            <b-form-input
              id="mc-whats-app-token"
              v-model="form.token"
              placeholder="WhatsApp Token"
              autocomplete="nope"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="WhatsApp Business ID"
            label-for="mc-whats-app-business-id"
          >
            <b-form-input
              id="mc-whats-app-business-id"
              v-model="form.waba_id"
              placeholder="WhatsApp Business ID"
              autocomplete="nope"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="WhatsApp Phone Number ID"
            label-for="mc-whatsapp-phone-number-id"
          >
            <b-form-input
              id="mc-whatsapp-phone-number-id"
              v-model="form.phone_number_id"
              placeholder="WhatsApp Phone Number ID"
              autocomplete="nope"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="d-flex justify-content-end align-items-center mt-1">
        <b-col md="4">
          <b-form-input
            v-model="testWhatsAppNumber"
            placeholder="Test WhatsApp Number"
          />
        </b-col>
        <b-col
          md="4"
          class="d-flex align-items-center"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1 w-100"
            @click="sendTestWhatsAppMessage"
          >
            Send Test Message
          </b-button>
        </b-col>
        <b-col
          md="4"
          class="d-flex align-items-center"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="w-100"
            @click="setWhatsAppConfig"
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BModal, BFormInput, BButton, VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const whatsAppSettingsRepository = RepositoryFactory.get('whatsAppSetting')

function initialState() {
  return {
    open: false,
    form: {},
    testWhatsAppNumber: '',
  }
}

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
    BButton,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  methods: {
    async openModal() {
      Object.assign(this.$data, initialState())
      this.open = true
      this.readWhatsAppConfig()
    },
    async readWhatsAppConfig() {
      try {
        const { data } = (await whatsAppSettingsRepository.getWhatsAppConfigResource()).data
        this.form = data
      } catch (e) {
        this.showErrorMessage('Sorry for the inconvenience! Please Try Again!!')
      }
    },
    async setWhatsAppConfig() {
      try {
        const res = await whatsAppSettingsRepository.updateWhatsAppConfigResource(this.form)
        if (res.status === 200) {
          this.showSuccessMessage('WhatsApp Configuration Updated Successfully')
          this.open = false
        } else {
          this.showErrorMessage('Cannot Update WhatsApp Configurations')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async sendTestWhatsAppMessage() {
      try {
        const payload = {
          phone: this.testWhatsAppNumber,
        }
        const res = await whatsAppSettingsRepository.sendTestWhatsAppMessage(payload)
        if (res.status === 200) {
          this.showSuccessMessage('WhatsApp Message Sent Successfully')
        } else {
          this.showErrorMessage('Cannot Send WhatsApp Message')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select.scss';
</style>
